/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExternalFileDto } from '../../models/external-file-dto';
import { RegisterExternalFileRequest } from '../../models/register-external-file-request';

export interface ExternalFilesRegisterRemotePost$Plain$Params {
      body?: RegisterExternalFileRequest
}

export function externalFilesRegisterRemotePost$Plain(http: HttpClient, rootUrl: string, params?: ExternalFilesRegisterRemotePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalFileDto>> {
  const rb = new RequestBuilder(rootUrl, externalFilesRegisterRemotePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExternalFileDto>;
    })
  );
}

externalFilesRegisterRemotePost$Plain.PATH = '/external-files/register-remote';
